import ProspectIndex from './Index'
import ProspectForm from './Form'

export default [
  {
    path: '/prospects',
    name: 'prospects',
    component: ProspectIndex,
    meta: {
      auth: true,
      breadcrumb: 'Prospects'
    }
  },
  {
    path: '/prospects/details/:oid',
    name: 'prospects.details',
    props: true,
    component: ProspectForm,
    meta: {
      breadcrumb: 'Prospect Details'
    }
  },
  {
    path: '/prospects/add',
    name: 'prospects.create',
    props: true,
    component: ProspectForm,
    meta: {
      breadcrumb: 'Add prospect'
    }
  }
]
